import React from "react";
import { OUTCOMES } from "@/lib/site";
import { Check } from "lucide-react";

export default function Outcomes() {
    return (
        <section
            id="outcomes"
            data-testid="outcomes-section"
            className="py-20 md:py-28 bg-white"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-3xl">
                    <div className="font-mono-label text-[color:var(--maroon)]">
                        Learning Outcomes
                    </div>
                    <h2
                        data-testid="outcomes-heading"
                        className="mt-3 font-serif text-4xl sm:text-5xl text-[color:var(--navy)] tracking-tight leading-tight"
                        style={{ fontWeight: 500 }}
                    >
                        What You Will Be Able To Do After This Series.
                    </h2>
                    <div className="hr-gold mt-5" />
                    <p className="mt-5 text-slate-600 leading-relaxed max-w-2xl">
                        This series is designed to help you{" "}
                        <span className="text-[color:var(--navy)] font-semibold">apply</span>{" "}
                        qualitative research, not just understand it in theory.
                    </p>
                </div>

                <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-4">
                    {OUTCOMES.map((o, i) => (
                        <div
                            key={i}
                            data-testid={`outcome-card-${i + 1}`}
                            className="group relative flex items-start gap-4 rounded-2xl border border-[color:var(--line)] bg-[color:var(--paper-tint)] p-6 hover:border-[color:var(--maroon)] hover:-translate-y-0.5 transition-all"
                        >
                            <div className="shrink-0">
                                <div className="relative">
                                    <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-white border border-[color:var(--line)] text-[color:var(--maroon)] group-hover:bg-[color:var(--maroon)] group-hover:text-white transition-colors">
                                        <Check className="h-4 w-4" />
                                    </span>
                                    <span className="absolute -bottom-1 -right-1 font-mono-label text-[9px] text-[color:var(--gold)]">
                                        {String(i + 1).padStart(2, "0")}
                                    </span>
                                </div>
                            </div>
                            <div>
                                <div className="font-mono-label text-slate-500 mb-1">
                                    Outcome {String(i + 1).padStart(2, "0")}
                                </div>
                                <p className="font-serif text-xl text-[color:var(--navy)] leading-snug">
                                    {o}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
